import Modal from './Modal.svelte';
import Overview from './Overview.svelte';
import { wishlist } from "./wishlist";
//import 'bootstrap';

const modal = new Modal({
	target: document.body,
	props: {
		//product_id: null,
		bundle_id: null,
		type: null,
		isModalOpen: false,
	}
});

function addButtonListeners() {
	//const menuCartButton = document.querySelector('.mini-cart');
	const quoteButtons = document.querySelectorAll('.addquotelistbutton');
	const cartButtons = document.querySelectorAll('.single_add_to_cart_button.button');
	const mobileMenuCartButtons = document.querySelectorAll('.floating-cart');
	const leaseButtons = document.querySelectorAll('.product-lease-button');
	const bundleButtons = document.querySelectorAll('.bundlebutton');

	// if (menuCartButton) {
	// 	menuCartButton.addEventListener("click", (e) => {
	// 		e.preventDefault();
	// 		openModal();
	// 	})
	// }

	if (mobileMenuCartButtons) {
		mobileMenuCartButtons.forEach((cartButton) => {
			cartButton.addEventListener("click", (e) => {
				e.preventDefault();
				console.log('geklikt');
				openModal();
			});
		});
	}


	if (quoteButtons) {
		quoteButtons.forEach((quoteButton) => {
			console.log('test');
			quoteButton.addEventListener("click", (e) => {
				e.preventDefault();
				console.log('geklikt');
				initModal(quoteButton, "quote")
			});
		});
	}

	if (cartButtons) {
		cartButtons.forEach((cartButton) => {
			cartButton.addEventListener("click", (e) => {
				e.preventDefault();
				console.log('geklikt');
				initModal(cartButton, "cart");
			});
		});
	}

	if (leaseButtons) {
		leaseButtons.forEach((leaseButton) => {
			leaseButton.addEventListener("click", (e) => {
				e.preventDefault();
				console.log('geklikt');
				initModal(leaseButton, "lease");
			});
		});
	}

	if (bundleButtons) {
		bundleButtons.forEach((bundleButton) => {
			bundleButton.addEventListener("click", (e) => {
				e.preventDefault();
				console.log('geklikt');
				initModal(bundleButton, "bundle");
			});
		});
	}
}

addButtonListeners();

window.addButtonListeners = addButtonListeners;

function openModal() {
	modal.$set({
		type: "cart",
		isModalOpen: true
	});
}

function initModal(button, type) {
	//const product_id = parseInt(button.getAttribute('data-product_id'));
	let product_id = button.getAttribute("value") || button.getAttribute("data-product_id");
	const product_title = button.getAttribute('data-product_title');
	const bundle_id = '10198';
	const quantity = jQuery('input.qty') && parseInt(jQuery('input.qty').val()) || 1;

	if (type === "quote") {
		verifyUTM();

		let variation_id = product_id;
		if (button.getAttribute('data-variation_id')) {
			variation_id = parseInt(button.getAttribute('data-variation_id'))
		}

		wishlist(button, variation_id, quantity);
		const quoteProducts = localStorage.getItem("products");
		const products = quoteProducts ? JSON.parse(quoteProducts) : [];

		if ( products.find(i => i.id === variation_id) ) {
			modal.$set({
				type: type,
				productTitle: product_title,
				isModalOpen: true
			});
			button.innerHTML = "verwijder";
		}
	} else if (type === "lease") {
		button.classList.add("is-loading");
		button.innerHTML = `<svg className="spinner" stroke="#fff" fill="#fff" xmlns="http://www.w3.org/2000/svg" version="1.0" width="18px" height="18px" viewBox="0 0 128 128" xmlSpace="preserve"><g transform="rotate(352.949 64.0001 64.0001)"><path d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z" fillOpacity="1" /><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="750ms" repeatCount="indefinite" /></g></svg>`;

		let variation_id;
		if (button.getAttribute('data-variation_id')) {
			variation_id = button.getAttribute('data-variation_id');
		}

		addProductToCart(product_id, quantity, variation_id).then(() => {
			modal.$set({
				product_id: product_id,
				type: type,
				isModalOpen: true
			});
			button.classList.remove("is-loading");
			button.innerHTML = "Start lease aanvraag";
		})
	} else if (type === "bundle"){

		let variation_id;

		if (button.getAttribute('data-variation_id')) {
			variation_id = button.getAttribute('data-variation_id');
		}

		console.log(variation_id);

		modal.$set({
			product_id: product_id,
			bundleId: bundle_id,
			type: type,
			isModalOpen: true
		});

		addProductToCart(product_id, quantity, variation_id).then(() => {
			modal.$set({
				product_id: product_id,
				type: type,
				isModalOpen: true
			});
			button.classList.remove("is-loading");
			button.innerHTML = "in winkelmand";
		})

	}else {
		button.classList.add("is-loading");
		button.innerHTML = `<svg className="spinner" stroke="#fff" fill="#fff" xmlns="http://www.w3.org/2000/svg" version="1.0" width="18px" height="18px" viewBox="0 0 128 128" xmlSpace="preserve"><g transform="rotate(352.949 64.0001 64.0001)"><path d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z" fillOpacity="1" /><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="750ms" repeatCount="indefinite" /></g></svg>`;

		let variation_id;
		if (button.getAttribute('data-variation_id')) {
			variation_id = button.getAttribute('data-variation_id');
		}

		

		addProductToCart(product_id, quantity, variation_id).then((key) => {
			console.log(product_id);
			console.log(key);
			modal.$set({
				product_id: product_id,
				type: type,
				isModalOpen: true,
				cartItemKey: key
			});
			button.classList.remove("is-loading");
			button.innerHTML = "in winkelmand";
		})
	}
}

const quoteOverview = document.querySelector('.quote-wrapper');

if (quoteOverview) {
	new Overview({
		target: quoteOverview
	});
}

async function addProductToCart(product_id, quantity = 1, variation_id = undefined) {
	const request = await fetch(window.digi_object.cart_rest_url + '/add-item', {
		method: 'POST',
		headers: {
			'content-type': 'application/json'
		},
		body: variation_id ? JSON.stringify({
			product_id,
			quantity,
			variation_id
		}) : JSON.stringify({
			product_id,
			quantity
		})
	});

	if (request.ok) {
		const response = await request.json();
	
		// let key = Object.keys(response).find(key => {
		//   return response[key].product_id === parseInt(product_id);
		// })
		//
		// if (variation_id) {
		//   key = Object.keys(response).find(key => {
		//     return response[key].variation_id === parseInt(variation_id);
		//   })
		// }
	
		return response.key;
	  } else {
		return false;
	  }
}


function verifyUTM() {
	const url = new URL(window.location.href);
	const source = url.searchParams.get("utm_source");

	if (source) {
		localStorage.setItem("utm_source", source);
	}
}

export default modal;
